import { render } from "./OJTOrgsDialog.vue?vue&type=template&id=4f6d02fd&scoped=true"
import script from "./OJTOrgsDialog.vue?vue&type=script&lang=js"
export * from "./OJTOrgsDialog.vue?vue&type=script&lang=js"

import "./OJTOrgsDialog.vue?vue&type=style&index=0&id=4f6d02fd&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f6d02fd"]])

export default __exports__